/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttachmentStorageAzureBlob extends models.AttachmentStorageBase {
    constructor() {
        super();
        this.setDiscriminator("AttachmentStorageAzureBlob");
    }

    getFixupPrototypeFunction() { return AttachmentStorageAzureBlob.fixupPrototype; }

    static newInstance(model: Partial<AttachmentStorageAzureBlob>): AttachmentStorageAzureBlob {
        let obj = Object.assign(new AttachmentStorageAzureBlob(), model);
        AttachmentStorageAzureBlob.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttachmentStorageAzureBlob>): AttachmentStorageAzureBlob {
        if (!model) return null;
        return AttachmentStorageAzureBlob.newInstance(<AttachmentStorageAzureBlob> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttachmentStorageAzureBlob) {
        if (!obj) return;

        models.AttachmentStorageAzureBlob.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttachmentStorageAzureBlob): boolean {
        if (models.AttachmentStorageBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttachmentStorageAzureBlob.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    secure_access_url: string;

    /**
     * Path to the blob in Azure storage
     */
    blob_path: string;

}
